<p-toast [baseZIndex]="10000"></p-toast>
<div class="container-fluid" [ngClass]="{'dark-mode': isDarkMode}">
  <!-- Header Component -->
  <app-header (toggleSidebarEvent)="sidebar.toggle()" [isSidebarOpen]="isSidebarOpen" [isSearchVisible]="false"
  [isNotificationVisible]="false" [isThemeVisible]="false"></app-header>

  <!-- Main Content Wrapper -->
  <div class="row" [ngClass]="{'overlay-active': isSidebarOpen}">

    <!-- Sidebar (Initially hidden on mobile) -->
    <div class="col-md-3 col-lg-2 sidebar-sticky" [class.sidebar-open]="isSidebarOpen">
      <app-sidebar2 #sidebar></app-sidebar2>
    </div>

    <!-- Main Content Area -->
    <div class="col-12 col-md-20 col-12 col-lg-10 main-content" [ngClass]="{'dark-mode': isDarkMode}">
      <!-- <app-toolbar title="{{ currentTitle }}"></app-toolbar> -->
      <div style="padding-left: 10px; padding-top: 5px; padding-bottom: 5px; background-color:whitesmoke;">
        <h1 class="page-title">{{ currentTitle }}</h1>
      </div>
      @if (loginDisplay) {
        <div>
          <router-outlet></router-outlet>
          <div class="spacer"></div>
        </div>
      }


    </div>
  </div>

  <!-- Footer Component -->
  <app-footer></app-footer>
</div>